import pako from 'pako'
import axios from "axios";

export const BASE_URL = process.env.REACT_APP_API_URL
export const publicClient = axios.create({ baseURL: BASE_URL })

export interface SpecItem {
    w: number
    h: number
    l: number
    name: string
    group: string
    count: number
    materialId?: string;
}

export interface CalculationDTO {
    id: string
    screenshots: string[]
    share_token: string
    data: any
    params: Record<string, any>
    spec: SpecItem[]
    information: Record<string, any>[]
    metadata: Record<string, any>
    leads: Record<string, any>
    visibility: string
    created_at: string
    calculator_id: string | null
}


export async function fetchCalculation(id: string): Promise<CalculationDTO> {
    const { data } = await publicClient.get(`/calculation/${id}`)
    const row = data.result
    const binary = atob(row.data)
    const bytes = new Uint8Array(binary.length)
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
    const decompressed = pako.ungzip(bytes, { to: 'string' })
    return { ...row, data: JSON.parse(decompressed) }
}
